import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getCropBasedMessage } from 'util/locale';
import { getActiveCropId } from 'current/currentSelectors';

// components
import BaseTrigger from 'triggers/BaseTrigger';

const baseString = 'vra-remove-seed-product-input-trigger';
const classString = classNames({
  [`${baseString}`]: true
});
const RemoveSeedInputTrigger = ({ isVisible, onClick }) => {
  const cropId = useSelector(getActiveCropId);

  return isVisible ? (
    <section className={classString}>
      <BaseTrigger
        className={`${baseString}__trigger`}
        content={getCropBasedMessage({ key: 'button-text__remove-dual-seed', cropId })}
        dataTestId={baseString}
        handler={onClick}
      />
    </section>
  ) : null;
};
RemoveSeedInputTrigger.propTypes = {
  isVisible: propTypes.bool.isRequired,
  onClick: propTypes.func.isRequired
};
export default RemoveSeedInputTrigger;
